<template>
  <div>
    <section>
      <el-col :span="24" class="tool-bar" style="padding-bottom: 0px">
        <el-form :inline="true">
          <el-form-item min-width="10%" label="时间范围：">
            <el-date-picker
              value-format="yyyy-MM-dd"
              @change="changeTime"
              v-model="timeInterval"
              type="daterange"
              range-separator="至"
              :start-placeholder=start_date
              :end-placeholder=end_date>
            </el-date-picker>
          </el-form-item>
          <el-form-item min-width="10%">
            <el-button type="primary" @click="queryList">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24" class="tool-bar" style="padding-bottom: 0px">
        <div class="keep">
          <div class="keep-name">当前总留存(元)</div>
          <div class="keep-value">{{allAcount}}</div>
        </div>
        <div class="keep">
          <div class="keep-name">查询区间留存(元)</div>
          <div class="keep-value">{{sectionAcount}}</div>
        </div>
      </el-col>
      <el-table stripe align="left" :data="tableData" highlight-current-row v-loading="listLoading"
                style="width: 100%;">
        <el-table-column type="index" align="center" prop="id" label="序号" min-width="10%">
        </el-table-column>
        <el-table-column align="center" prop="time" label="日期"  :formatter="formatTime" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="redPacketAccount" label="推页红包(元)" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="shareAccount" label="转发佣金(元)" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="withdrowAccount" label="钱包提现(元)" min-width="20%"></el-table-column>
        <el-table-column align="center" prop="currentDayAccount" label="当日留存" min-width="40%"></el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page=currentPage
        :page-sizes="[10, 20, 30, 40]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </section>
  </div>
</template>

<script>

  export default {
    name: "withdraw-data",
    data() {
      return {
        selectedNum: 1,
        tableData: [],
        listLoading: false,
        currentPage: 0,
        pageSize: 10,
        total: 0,
        start_date: '开始日期',
        end_date: '结束日期',
        timeInterval: '',
        fileList: [],
        sectionAcount: 0,
        allAcount: ''
      }
    },
    methods: {
      queryList() {
        let param = {
          currentPage: this.currentPage == 0 ? this.currentPage : this.currentPage - 1,
          pageSize: this.pageSize,
          startTime: this.timeInterval == null ? null : this.timeInterval[0],
          endTime: this.timeInterval == null ? null : this.timeInterval[1]
        }
        console.log(param);
        this.$http.post(this, '/statement/getFinanceData', param).then(res => {
          console.log(res);
          this.tableData = res.content
          this.pageSize = res.size
          this.total = res.totalElements
        })
        this.$http.post(this, '/statement/getSectionAcount', param).then(res => {
          console.log(res);
          this.sectionAcount = res
        })
      },
      changeTime() {
        console.log(this.timeInterval);
        this.start_date = this.timeInterval == null ? '开始日期' : this.timeInterval[0]
        this.end_date = this.timeInterval == null ? '结束日期' : this.timeInterval[1]
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.queryList()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        console.log(val + ':' + this.currentPage);
        this.queryList()
      },
      formatTime(row, column) {
        if (!row.time) {
          return '';
        }
        return new Date(row.time).format("yyyy年MM月dd日");
      },
      getAllAcount() {
        this.$http.post(this, '/statement/getAllAcount').then(res => {
          this.allAcount = res==null?0:res
        })
      }
    },
    created() {
      this.queryList()
      this.getAllAcount()
    }
  }
</script>

<style scoped>
  .tool-bar {
    background: #f2f2f2;
    padding: 10px;
    margin: 10px 0px;

  .el-form-item {
    margin-bottom: 10px;
    width: 20%;
  }

  }

  .keep {
    display: inline-block;
    margin-right: 15%;
  }

  .keep-name {
    font-size: 13px;
    color: rgba(0, 0, 0, .6);

  }

  .keep-value {
    font-size: 40px;
    font-weight: 600;
    color: #20A0FF;
  }
</style>
